import { useEffect, useMemo, useState } from 'react'

import { useFormField } from '@workwave-tidal/form-fairy'
import { TextField } from '@workwave-tidal/core/components'

import { type FormErrors, type FormFields } from '../../../../../formFields'
import { useTexts } from '../../../../../useTexts'

export function Username() {
  const [username, setUsername] = useState<string>('')
  const { fieldApi, errors } = useFormField<'credentials', FormFields, FormErrors>('credentials')

  const texts = useTexts()

  const { helperText, error } = useMemo(() => {
    const usernameErrors = errors.filter(e => e.index === 0)
    if (usernameErrors.length === 0) {
      return {
        helperText: '',
        error: false,
      }
    }

    return {
      helperText: usernameErrors[0].message,
      error: true,
    }
  }, [errors])

  useEffect(() => {
    const passwordCredential = fieldApi
      .getField()
      .value.find(credential => credential.fieldName === 'password') ?? {
      fieldName: 'password',
      value: '',
    }

    fieldApi.change([{ fieldName: 'username', value: username }, passwordCredential])
  }, [username, fieldApi])

  return (
    <TextField
      name="username"
      size="medium"
      label={texts.verizonConnect.usernameLabel}
      value={username}
      error={error}
      onChange={e => setUsername(e.target.value)}
      helperText={helperText}
      InputProps={{
        autoComplete: 'one-time-code',
      }}
    />
  )
}
